<script>
import moment from "moment";
import axios from '@/utils/axios';

export default {
  inject: ['setLoading'],
  data() {
    return {
      title: "HRM",
      text: "Assets",
      text1: "My Assets",
      assets: [],
    };
  },

  mounted() {
    this.getMyAssets();
  },

  methods: {
    async getMyAssets() {
      this.setLoading(true);
      try {
        const response = await axios.get('/hrms/assets/my');
        this.assets = response.data.data || [];
      } catch (error) {
        this.$swalToast(error.message || 'Failed to load assets', 'error');
      } finally {
        this.setLoading(false);
      }
    },

    formatDate(dateStr) {
      if (!dateStr) return '-';
      return moment(dateStr).format('DD MMM, YYYY');
    },

    statusBadgeClass(status) {
      const map = {
        active: 'bg-success-subtle text-success',
        returned: 'bg-secondary-subtle text-secondary',
        lost: 'bg-danger-subtle text-danger',
        damaged: 'bg-warning-subtle text-warning',
      };
      return map[status] || 'bg-secondary-subtle text-secondary';
    },
  }
};
</script>

<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">

      <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <breadcrumb :title="title" :text="text" :text1="text1" />
      </div>

      <div class="row g-3">
        <div class="col-md-4 col-sm-6" v-for="item in assets" :key="item.id">
          <div class="card shadow-sm h-100">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-start mb-2">
                <h6 class="fw-bold mb-0">{{ item.asset?.name || '-' }}</h6>
                <span class="badge rounded-pill" :class="statusBadgeClass(item.status)">{{ item.status }}</span>
              </div>
              <p class="text-muted mb-1" style="font-size:12px;">
                <i class="ti ti-tag me-1"></i>{{ item.asset?.code || '-' }}
              </p>
              <p class="text-muted mb-1" style="font-size:12px;">
                <i class="ti ti-category me-1"></i>{{ item.asset?.category?.name || '-' }}
              </p>
              <p class="text-muted mb-1" style="font-size:12px;" v-if="item.asset?.brand || item.asset?.model">
                <i class="ti ti-device-desktop me-1"></i>{{ item.asset?.brand }} {{ item.asset?.model }}
              </p>
              <hr>
              <div class="d-flex justify-content-between" style="font-size:12px;">
                <span class="text-muted">Assigned</span>
                <span class="fw-medium">{{ formatDate(item.assigned_date) }}</span>
              </div>
              <div class="d-flex justify-content-between" style="font-size:12px;" v-if="item.returned_date">
                <span class="text-muted">Returned</span>
                <span class="fw-medium">{{ formatDate(item.returned_date) }}</span>
              </div>
              <div class="d-flex justify-content-between" style="font-size:12px;">
                <span class="text-muted">Quantity</span>
                <span class="fw-medium">{{ item.quantity }}</span>
              </div>
              <div class="mt-2" v-if="item.notes">
                <small class="text-muted">{{ item.notes }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!assets.length" class="text-center text-muted p-5">
        <i class="ti ti-package fs-1 d-block mb-2"></i>
        No assets assigned to you.
      </div>

    </div>
    <app-footer></app-footer>
  </div>
</template>